import loadMessageSuggestion from './actions/loadMessageSuggestion';
import { LazyAction, LazyImport, LazyModule } from 'owa-bundling';
import './orchestrators/loadMessageSuggestionOrchestrator';
var lazyModule = new LazyModule(function () {
    return System.import(
    /* webpackChunkName: "SearchActions", webpackPrefetch: true */ './lazyIndex');
});
// Delay loaded actions
export var lazyStartSearch = new LazyAction(lazyModule, function (m) { return m.startSearch; }).importAndExecute;
export var lazyChangeSearchScope = new LazyAction(lazyModule, function (m) { return m.changeSearchScope; })
    .importAndExecute;
export var lazyOnSelectingFolder = new LazyAction(lazyModule, function (m) { return m.onSelectingFolder; })
    .importAndExecute;
export var lazyStartSearchSession = new LazyAction(lazyModule, function (m) { return m.startSearchSession; });
export var lazyEndSearchSession = new LazyAction(lazyModule, function (m) { return m.endSearchSession; })
    .importAndExecute;
export var lazyResetSearchScope = new LazyAction(lazyModule, function (m) { return m.resetSearchScope; })
    .importAndExecute;
export var lazySetStaticSearchScope = new LazyAction(lazyModule, function (m) { return m.setStaticSearchScope; })
    .importAndExecute;
export var lazyCreateFallbackPersonaSearchTableQuery = new LazyImport(lazyModule, function (m) { return m.createFallbackPersonaSearchTableQuery; });
export var lazyCreateFallbackCategorySearchTableQuery = new LazyImport(lazyModule, function (m) { return m.createFallbackCategorySearchTableQuery; });
export var lazyShowSxSForFileSuggestion = new LazyAction(lazyModule, function (m) { return m.showSxSForFileSuggestion; }).importAndExecute;
export var lazyStartSearchWithCategory = new LazyAction(lazyModule, function (m) { return m.startSearchWithCategory; }).importAndExecute;
export var lazyChangeFolderScopeAndExecute = new LazyAction(lazyModule, function (m) { return m.changeSearchScopeAndExecute; }).importAndExecute;
export var lazyLoadMessageSuggestion = new LazyImport(lazyModule, function (m) { return m.loadMessageSuggestion; });
export { ReactListViewType, loadMessageSuggestion, };
//# sourceMappingURL=index.js.map